// 导出页面为PDF格式
import html2Canvas from 'html2canvas'
import Canvas2Image from './Canvas2Image'
import JsPDF from 'jspdf'
// const htmlToImg={
//   downloadForJs(){
//       var title = this.htmlTitle
//       console.log("111111");
//       const domElement=document.querySelector('#pdfDom');
//       html2Canvas(
//         domElement, 
//         {
//           allowTaint: true,
//           useCORS : true,
//           onclone:(document)=>{
//             document.querySelector('#printButton').style.visibility='hidden'
//           }
//         }).then(function(canvas) { 
//   　　　　if(IE){ //判断IE下保存方法
//   　　 　　 var blob = canvas.msToBlob();
//   　　 　　 window.navigator.msSaveBlob(blob, fileName);
//   　　　　}else{//其他浏览器保存方法
//   　　　　　var imgUri = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream"); // 获取生成的图片的url 　
//   　　　　  var saveLink = document.createElement( 'a');
//   　　 　　 saveLink.href =imgUri;
//   　　　　  saveLink.download = fileName; saveLink.click();
//   　　　　}
//   });

//   },
//   productionImage() {
//     // 手动创建一个 canvas 标签
//     const canvas = document.createElement("canvas")
//     // 获取父标签，意思是这个标签内的 DOM 元素生成图片
//     let canvasBox = this.$refs.wrapper
//     // 获取父级的宽高
//     const width = parseInt(window.getComputedStyle(canvasBox).width)
//     const height = parseInt(window.getComputedStyle(canvasBox).height)
    
//    // 宽高 * 2 并放大 2 倍 是为了防止图片模糊
//     canvas.width = width * 2
//     canvas.height = height * 2
//     canvas.style.width = width + 'px'
//     canvas.style.height = height + 'px'
   
//     const context = canvas.getContext("2d");
//     context.scale(2, 2);
 
//     const options = {
//       backgroundColor: null,
//       canvas: canvas,
//       useCORS: true
//     }
//     html2Canvas(canvasBox, options).then((canvas) => {
//       // toDataURL 图片格式转成 base64
//       let dataURL = canvas.toDataURL("image/png")
//       this.downloadImage(dataURL)
//     })
//   },
 
//   downloadImage(url) {
//    // 创建一个 img 标签，把图片插入到 DOM 中
//     // 这里使用 img 是因为在客户端中，不能直接下载，要调用原生的方法
//     const parents = this.$refs.selfReport
//     const createImg = document.createElement('img')
//     const insertEle = this.$refs.insetElement
//     parents.insertBefore(createImg,parents.childNodes[0])
  
//     createImg.setAttribute('src', url)
 
//     // 如果是在网页中可以直接创建一个 a 标签直接下载 
//       let a = document.createElement('a')
//       a.href = url
//       a.download = '文件名'
//       a.click()
//   }




export default {
  install (Vue, options) {
    Vue.prototype.getImg = function () {
      var fileName = this.htmlTitle+'.png';
      var domElement=document.querySelector('#pdfDom');

      // //防止偏移
      // var width = domElement.offsetWidth;
      // var height = domElement.offsetHeight;
      // var scale = 2;
      // //放大倍数
      // var canvas =document.createElement('canvas');
      // canvas.width = width * 2;
      // canvas.height = height * 2;
      // canvas.style.width = width +  'px';
      // canvas.style.height = height +  'px';
      // var context = canvas.getContext('2d');
      // context.scale(scale, scale);



      html2Canvas(
        domElement, 
        {
          allowTaint: true,
          useCORS : true,
          scrollY: 0
        }).then(function(canvas) { 
  　　　　if(!!window.ActiveXObject || "ActiveXObject" in window){ //判断IE下保存方法
  　　 　　 var blob = canvas.msToBlob();
  　　 　　 window.navigator.msSaveBlob(blob, fileName);
  　　　　}else{
  　　　　　var imgUri = canvas.toDataURL("image/png") // 获取生成的图片的url 　
          // 创建一个 img 标签，把图片插入到 DOM 中
          // 这里使用 img 是因为在客户端中，不能直接下载，要调用原生的方法
          const createImg = document.querySelector('#taskImage');
          createImg.setAttribute('src', imgUri);
          createImg.setAttribute('width', '100%');
          domElement.remove();
          // parents.appendChild(createImg)




  　　　　}
  });
  }
  Vue.prototype.clickImgButton=function () {
    var fileName = this.htmlTitle+'.png';
    var domElement=document.querySelector('#pdfDom');
    html2Canvas(
      domElement, 
      {
        allowTaint: true,
        useCORS : true,
        scrollY: 0,
        onclone:(document)=>{
          document.querySelector('#printButton').style.visibility='hidden'
        }
      }).then(function(canvas) { 
　　　　if(!!window.ActiveXObject || "ActiveXObject" in window){ //判断IE下保存方法
　　 　　 var blob = canvas.msToBlob();
　　 　　 window.navigator.msSaveBlob(blob, fileName);
　　　　}else{//其他浏览器保存方法
　　　　　var imgUri = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream"); // 获取生成的图片的url 　
　　　　  var saveLink = document.createElement( 'a');
　　 　　 saveLink.href =imgUri;
　　　　  saveLink.download = fileName; 
        saveLink.click();
        console.log("下载完成");
　　　　}
});
}
}
}


// WEBPACK FOOTER //
// ./src/components/utils/htmlToImg.js